import { render } from "./PricingPage.vue?vue&type=template&id=3a16ab57"
const script = {}

import "./PricingPage.vue?vue&type=style&index=0&id=3a16ab57&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__